/**
 * Opens and closes the header language dialog.
 *
 * `showModal()` is doing most of the work that would otherwise be hand-written:
 * the page behind goes inert, focus is trapped, Escape closes, and the backdrop
 * is a real pseudo-element rather than an extra div. What is left here is the
 * opening, the click-outside, and returning focus.
 */
(() => {
  class LanguagePicker extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.trigger = this.querySelector('[data-lgp-open]');
      this.dialog = this.querySelector('[data-lgp-dialog]');
      if (!this.trigger || !this.dialog) return;

      this.trigger.addEventListener('click', () => this.open());

      const close = this.querySelector('[data-lgp-close]');
      if (close) close.addEventListener('click', () => this.dialog.close());

      // A modal dialog's backdrop is part of the dialog element, so a click on
      // the backdrop reports the dialog itself as the target. Anything inside the
      // panel reports the panel or its children.
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });

      this.dialog.addEventListener('close', () => {
        this.trigger.setAttribute('aria-expanded', 'false');
        // Escape and the backdrop both land here, so focus is restored from one
        // place rather than from each way of closing.
        this.trigger.focus();
      });
    }

    open() {
      // `showModal` throws if the dialog is already open, which can happen when
      // the theme editor re-renders the header under an open dialog.
      if (this.dialog.open) return;
      this.dialog.showModal();
      this.trigger.setAttribute('aria-expanded', 'true');

      // Start on the language in use, so the list opens where the shopper is.
      const current = this.dialog.querySelector('.lgp__option--current');
      if (current) current.focus();
    }
  }

  if (!customElements.get('language-picker')) {
    customElements.define('language-picker', LanguagePicker);
  }
})();
